export default class TableRowModel {
  public value: Record<string, any>;

  constructor(public columns: string[]) {
    const rowEntry = columns.map((col) => [col, '']);
    const rawRow = Object.fromEntries(rowEntry);
    this.value = rawRow;
  }
}